// Modules
import { memo } from 'react'

const SpinnerSVG = ({ w = 520, h = 520 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={w}
      height={h}
      x="0"
      y="0"
      viewBox="0 0 512 512"
    >
      <circle
        cx="451.792"
        cy="340.182"
        r="49"
        fill="#e9ae2b"
        transform="rotate(-73.38 451.734 340.286)"
        opacity="0.6392156862745098"
        data-original="#f9ac00"
        className=""
      />
      <path
        fill="#b89e1e"
        fillRule="evenodd"
        d="M450.261 389.157c-26.353-.809-47.469-22.424-47.469-48.974s21.116-48.165 47.469-48.974c26.353.809 47.47 22.424 47.47 48.974s-21.116 48.165-47.47 48.974z"
        opacity="1"
        data-original="#fcdb35"
        className=""
      />
      <circle
        cx="451.792"
        cy="340.182"
        r="39.095"
        fill="#e0caa3"
        transform="rotate(-45 451.764 340.29)"
        opacity="1"
        data-original="#f19a00"
        className=""
      />
      <path
        fill="#e9ae2b"
        fillRule="evenodd"
        d="M454.307 301.17c20.419 1.297 36.58 18.266 36.58 39.012s-16.161 37.716-36.58 39.012c-20.419-1.297-36.58-18.266-36.58-39.012s16.161-37.715 36.58-39.012z"
        opacity="0.6392156862745098"
        data-original="#f9ac00"
        className=""
      />
      <rect
        width="97.802"
        height="27.468"
        x="402.792"
        y="445.87"
        fill="#e0caa3"
        rx="6.659"
        opacity="1"
        data-original="#f19a00"
        className=""
      />
      <path
        fill="#e0caa3"
        d="M409.45 473.338h84.485a6.662 6.662 0 0 1 6.659 6.659v14.15a6.662 6.662 0 0 1-6.659 6.659H409.45a6.662 6.662 0 0 1-6.659-6.659v-14.151a6.66 6.66 0 0 1 6.658-6.658z"
        opacity="1"
        data-original="#fdc72e"
        className=""
      />
      <rect
        width="97.802"
        height="27.468"
        x="402.792"
        y="418.403"
        fill="#b89e1e"
        rx="6.659"
        opacity="1"
        data-original="#fdc72e"
        className=""
      />
      <path
        fill="#e0caa3"
        d="M409.45 390.935h84.486a6.66 6.66 0 0 1 6.658 6.658v14.15a6.662 6.662 0 0 1-6.659 6.659H409.45a6.662 6.662 0 0 1-6.659-6.659v-14.151a6.66 6.66 0 0 1 6.658-6.658z"
        opacity="1"
        data-original="#f19a00"
        className=""
      />
      <g fillRule="evenodd">
        <path
          fill="#e9ae2b"
          d="M409.451 390.935h74.925c1.029 0 1.868.839 1.868 1.868v14.041c0 3.662-2.996 6.659-6.659 6.659H404.66a1.871 1.871 0 0 1-1.868-1.868v-14.041c0-3.662 2.996-6.658 6.659-6.658z"
          opacity="0.6392156862745098"
          data-original="#f9ac00"
          className=""
        />
        <path
          fill="#b89e1e"
          d="M409.451 418.403h74.925c1.029 0 1.868.839 1.868 1.868v14.041c0 3.662-2.996 6.659-6.659 6.659H404.66a1.871 1.871 0 0 1-1.868-1.868v-14.041c0-3.662 2.996-6.659 6.659-6.659z"
          opacity="1"
          data-original="#fcdb35"
          className=""
        />
        <path
          fill="#e9ae2b"
          d="M409.451 445.87h74.925c1.029 0 1.868.839 1.868 1.868v14.041c0 3.662-2.996 6.659-6.659 6.659H404.66a1.871 1.871 0 0 1-1.868-1.868v-14.041c0-3.662 2.996-6.659 6.659-6.659z"
          opacity="0.6392156862745098"
          data-original="#f9ac00"
          className=""
        />
        <path
          fill="#b89e1e"
          d="M409.451 473.338h74.925c1.029 0 1.868.839 1.868 1.868v14.041c0 3.662-2.996 6.659-6.659 6.659H404.66a1.871 1.871 0 0 1-1.868-1.868v-14.041c0-3.662 2.996-6.659 6.659-6.659z"
          opacity="1"
          data-original="#fcdb35"
          className=""
        />
      </g>
      <path
        fill="#99b5ed"
        d="M210.619 252.095h32.99v95.967h-32.99z"
        opacity="1"
        data-original="#fdc72e"
        className=""
      />
      <path
        fill="#99b5ed"
        d="M152.841 301.581h32.99v46.481h-32.99z"
        opacity="1"
        data-original="#fb545c"
        className=""
      />
      <path
        fill="#99b5ed"
        d="M268.396 268.974h32.99v79.088h-32.99z"
        opacity="1"
        data-original="#99b5ed"
        className=""
      />
      <path
        fill="#99b5ed"
        d="M326.174 216.993h32.99v131.069h-32.99z"
        opacity="1"
        data-original="#4eb1fc"
        className=""
      />
      <g fillRule="evenodd">
        <path
          fill="#99b5ed"
          d="M223.884 199.844c6.658-1.784 13.502 2.167 15.286 8.825s-2.167 13.502-8.826 15.286c-6.658 1.784-13.502-2.167-15.286-8.826-1.784-6.658 2.167-13.502 8.826-15.286z"
          opacity="1"
          data-original="#fdc72e"
          className=""
        />
        <path
          fill="#99B5ED"
          d="M281.661 222.35c6.658-1.784 13.502 2.167 15.286 8.826 1.784 6.658-2.167 13.502-8.826 15.286s-13.502-2.167-15.286-8.825 2.167-13.502 8.825-15.286z"
          opacity="1"
          data-original="#99B5ED"
          className=""
        />
        <path
          fill="#99b5ed"
          d="M339.648 164.362c6.658-1.784 13.502 2.167 15.286 8.826s-2.167 13.502-8.825 15.286-13.502-2.167-15.286-8.825 2.167-13.502 8.826-15.286z"
          opacity="1"
          data-original="#4eb1fc"
          className=""
        />
        <path
          fill="#99b5ed"
          d="M166.106 256.766c6.658-1.784 13.502 2.167 15.286 8.826 1.784 6.658-2.167 13.502-8.826 15.286-6.658 1.784-13.502-2.167-15.286-8.826s2.167-13.502 8.825-15.286z"
          opacity="1"
          data-original="#fb545c"
          className=""
        />
      </g>
      <circle
        cx="95.77"
        cy="389.925"
        r="60.078"
        fill="#9dc19f"
        opacity="1"
        data-original="#29b933"
        className=""
      />
      <path
        fill="#7dbe7d"
        fillRule="evenodd"
        d="M89.395 449.666c-30.183-3.184-53.703-28.714-53.703-59.741s23.52-56.557 53.703-59.741c30.183 3.184 53.703 28.715 53.703 59.741s-23.52 56.557-53.703 59.741z"
        opacity="1"
        data-original="#2dd62d"
        className=""
      />
      <circle
        cx="416.785"
        cy="122.73"
        r="29.256"
        fill="#ffffff"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth="10"
        transform="rotate(-45 416.794 122.815)"
        opacity="1"
        data-original="#ffffff"
        className=""
      />
      <path
        fill="#5d689e"
        fillRule="evenodd"
        d="M405.035 77.192 392.9 82.225l-9.709-6.511-13.422 13.422 6.512 9.709-5.034 12.135-11.462 2.26v18.98l11.462 2.26 5.034 12.135-6.512 9.709 13.422 13.422 9.709-6.512 12.135 5.034 2.26 11.462h18.981l2.26-11.462 12.134-5.034 9.709 6.512 13.422-13.422-6.511-9.709 5.033-12.135 11.462-2.26v-18.98l-11.462-2.26-5.033-12.135 6.511-9.709-13.422-13.422-9.709 6.511-12.134-5.033-2.26-11.462h-18.981z"
        opacity="1"
        data-original="#5d689e"
        className=""
      />
      <path
        fill="#7986bf"
        fillRule="evenodd"
        d="m405.035 77.192-4.54 1.883-.077.032-7.518 3.118-.005-.003-2.578 1.067-8.8-5.901-11.747 11.748 6.511 9.709-5.034 12.135-11.462 2.26v18.98l11.462 2.26 5.034 12.135-6.511 9.709 11.748 11.748 8.799-5.901 2.577 1.067.006-.004 12.135 5.034 2.26 11.462h16.013l2.367-12.005 13.402-5.559 1.593 1.068 7.214 4.838 11.748-11.748-6.511-9.709 6.052-14.632 10.443-2.059v-14.388l-10.443-2.059-6.052-14.632 6.511-9.709-11.748-11.748-8.807 5.906-13.402-5.559-2.367-12.005h-16.013z"
        opacity="1"
        data-original="#7986bf"
        className=""
      />
      <circle
        cx="413.108"
        cy="122.729"
        r="29.432"
        fill="#5d689e"
        transform="rotate(-19.4 413.612 122.81)"
        opacity="1"
        data-original="#5d689e"
        className=""
      />
      <circle
        cx="416.785"
        cy="122.729"
        r="29.431"
        fill="#f3f3ff"
        opacity="1"
        data-original="#f3f3ff"
        className=""
      />
      <path
        fill="#99b5ed"
        d="M348.959 216.993h10.205v131.069h-10.205z"
        opacity="1"
        data-original="#2a92fa"
        className=""
      />
      <path
        fill="#99b5ed"
        d="M291.181 268.974h10.205v79.088h-10.205z"
        opacity="1"
        data-original="#99b5ed"
        className=""
      />
      <path
        fill="#99b5ed"
        d="M233.404 252.095h10.205v95.967h-10.205z"
        opacity="0.6392156862745098"
        data-original="#99b5ed"
        className=""
      />
      <path
        fill="#99b5ed"
        d="M175.626 301.581h10.205v46.481h-10.205z"
        opacity="1"
        data-original="#e8333c"
        className=""
      />
      <path
        fill="#7dbe7d"
        d="M10.824 10.909h282v139.915h-282z"
        opacity="1"
        data-original="#2dd62d"
        className=""
      />
      <path
        fill="#9dc19f"
        fillRule="evenodd"
        d="M260.925 25.557c-1.442 10.476 5.428 17.49 12.494 17.49v23.276H30.229V43.047c7.065 0 13.935-7.014 12.494-17.49h218.203z"
        opacity="1"
        data-original="#29b933"
        className=""
      />
      <path
        fill="#b5dcb5"
        fillRule="evenodd"
        d="M47.718 30.313h208.211c0 9.659 7.83 17.49 17.49 17.49v66.126c-9.66 0-17.49 7.831-17.49 17.49H47.718c0-9.66-7.83-17.49-17.49-17.49V47.803c9.659 0 17.49-7.831 17.49-17.49z"
        opacity="1"
        data-original="#96ff96"
        className=""
      />
      <path
        fill="#9dc19f"
        d="M286.291 10.909h6.533v139.915h-6.533z"
        opacity="1"
        data-original="#29b933"
        className=""
      />
      <path
        fill="#021047"
        fillRule="evenodd"
        d="M393.679 122.734c0-12.739 10.36-23.109 23.101-23.109s23.11 10.37 23.11 23.109-10.37 23.101-23.11 23.101-23.101-10.36-23.101-23.101zm58.21 0c0-19.36-15.747-35.108-35.109-35.108s-35.099 15.749-35.099 35.108 15.752 35.101 35.099 35.101 35.109-15.751 35.109-35.101zm-62.228 35.34a6.002 6.002 0 0 1 5.643-.559l12.08 5.02a5.967 5.967 0 0 1 3.59 4.38l1.296 6.569h9.03l1.301-6.569a5.956 5.956 0 0 1 3.58-4.38l12.09-5.02a5.991 5.991 0 0 1 5.638.559l5.57 3.74 6.38-6.391-3.73-5.57a5.994 5.994 0 0 1-.559-5.639l5.011-12.08a5.99 5.99 0 0 1 4.38-3.59l6.577-1.301v-9.029l-6.577-1.301a5.977 5.977 0 0 1-4.38-3.58l-5.011-12.09a5.997 5.997 0 0 1 .559-5.639l3.73-5.57-6.38-6.381-5.57 3.731a5.994 5.994 0 0 1-5.638.561l-12.09-5.011a5.977 5.977 0 0 1-3.58-4.38l-1.301-6.569h-9.03l-1.296 6.569a5.988 5.988 0 0 1-3.59 4.38l-12.08 5.011a6.006 6.006 0 0 1-5.643-.561l-5.57-3.731-6.389 6.381 3.739 5.57a5.983 5.983 0 0 1 .559 5.639l-5.006 12.09a5.992 5.992 0 0 1-4.39 3.58l-6.573 1.301v9.029l6.573 1.301a6 6 0 0 1 4.39 3.59l5.006 12.08a5.98 5.98 0 0 1-.559 5.639l-3.739 5.57 6.389 6.391zm11.791 22.571a5.997 5.997 0 0 0 5.879 4.84h18.899a6.008 6.008 0 0 0 5.893-4.84l1.629-8.26 6.139-2.551 7.002 4.691a5.983 5.983 0 0 0 7.58-.742l13.367-13.358a6.021 6.021 0 0 0 .742-7.591l-4.688-6.989 2.54-6.15 8.269-1.63a6.002 6.002 0 0 0 4.843-5.88v-18.9a6.01 6.01 0 0 0-4.843-5.89l-8.269-1.63-2.54-6.14 4.688-7a6.005 6.005 0 0 0-.742-7.58l-13.367-13.37a6.01 6.01 0 0 0-7.58-.74l-7.002 4.689-6.139-2.539-1.629-8.26a6 6 0 0 0-5.893-4.842h-18.899a5.988 5.988 0 0 0-5.879 4.842l-1.634 8.26-6.149 2.539-6.987-4.689a6.022 6.022 0 0 0-7.589.74l-13.362 13.37a5.986 5.986 0 0 0-.742 7.58l4.693 7-2.554 6.14-8.259 1.63a6.005 6.005 0 0 0-4.838 5.89v18.9a5.997 5.997 0 0 0 4.838 5.88l8.259 1.63 2.554 6.15-4.693 6.989a6.002 6.002 0 0 0 .742 7.591l13.362 13.358a5.997 5.997 0 0 0 7.589.742l6.987-4.691 6.149 2.551zm-281.449 231.4c0 2.58-2.101 4.67-4.674 4.67s-4.655-2.089-4.655-4.67v-2.961c0-2.569 2.087-4.659 4.655-4.659s4.674 2.089 4.674 4.659zm-4.674-19.619c-9.189 0-16.658 7.469-16.658 16.658v2.961c0 9.2 7.469 16.669 16.658 16.669s16.672-7.469 16.672-16.669v-2.961c0-9.189-7.479-16.658-16.672-16.658zm-43.787-21.662v-2.959c0-2.571 2.091-4.67 4.66-4.67a4.672 4.672 0 0 1 4.669 4.67v2.959c0 2.58-2.087 4.67-4.669 4.67a4.667 4.667 0 0 1-4.66-4.67zm21.327 0v-2.959c0-9.191-7.479-16.67-16.668-16.67s-16.658 7.478-16.658 16.67v2.959c0 9.191 7.469 16.669 16.658 16.669s16.668-7.478 16.668-16.669zm25.775-8.459a6.002 6.002 0 0 0-2.193-8.201 6.016 6.016 0 0 0-8.201 2.201l-35.36 61.24a6.004 6.004 0 0 0 2.202 8.199c.94.55 1.971.812 2.988.812a5.978 5.978 0 0 0 5.199-3.012l35.364-61.239zM95.77 444.004c29.823 0 54.08-24.259 54.08-54.081s-24.257-54.08-54.08-54.08-54.08 24.261-54.08 54.08 24.262 54.081 54.08 54.081zm63.072-136.42h20.99v34.48h-20.99zm-7.792 46.211a6.267 6.267 0 0 0 1.793.269h32.988a6.003 6.003 0 0 0 5.999-6.001v-46.48a5.997 5.997 0 0 0-5.999-5.999h-32.988a5.996 5.996 0 0 0-5.999 5.999v46.461c-12.133-14.761-30.521-24.2-51.073-24.2-36.439 0-66.079 29.65-66.079 66.079s29.64 66.08 66.079 66.08 66.083-29.639 66.083-66.08c0-13.329-3.99-25.739-10.803-36.129zm343.952 140.5a.727.727 0 0 1-.704.709h-85.016a.728.728 0 0 1-.704-.709v-14.242c0-.369.332-.7.704-.7h85.016c.371 0 .704.331.704.7zm0-41.881v14.239c0 .38-.332.7-.704.7h-85.016a.718.718 0 0 1-.704-.7v-14.239c0-.369.332-.7.704-.7h85.016c.371 0 .704.331.704.7zm0-13.4c0 .371-.332.7-.704.7h-85.016a.725.725 0 0 1-.704-.7v-14.239c0-.01.014-.701.332-.701h85.011c.549 0 1.06.51 1.079.701v14.239zm-86.423-41.879c0-.37.332-.7.704-.7h85.016c.371 0 .704.33.704.7v14.24c0 .369-.332.7-.704.7v.019c-.125 0-.246-.019-.376-.019h-84.64a.726.726 0 0 1-.704-.7zm0-56.93c0-23.83 19.381-43.21 43.214-43.21s43.209 19.38 43.209 43.21-19.381 43.21-43.209 43.21-43.214-19.38-43.214-43.21zm85.719 44.23h-9.497C498.274 374.354 507 358.284 507 340.205c0-30.44-24.768-55.211-55.208-55.211s-55.212 24.771-55.212 55.211c0 18.079 8.731 34.149 22.2 44.23h-9.497c-7.002 0-12.702 5.7-12.702 12.7v14.24a12.6 12.6 0 0 0 1.87 6.599 13.168 13.168 0 0 0-1.87 6.801v14.239c0 2.46.708 4.751 1.932 6.701a12.543 12.543 0 0 0-1.932 6.699v14.239c0 2.46.708 4.761 1.932 6.701a12.543 12.543 0 0 0-1.932 6.699v14.242c0 7.01 5.7 12.709 12.702 12.709h85.016c7.002 0 12.702-5.7 12.702-12.709v-14.242c0-2.46-.708-4.749-1.927-6.699a12.567 12.567 0 0 0 1.927-6.701v-14.239c0-2.46-.708-4.749-1.927-6.699a12.59 12.59 0 0 0 1.927-6.701v-14.239c0-2.4-.737-4.661-1.99-6.6a12.638 12.638 0 0 0 1.99-6.801v-14.24c0-7-5.7-12.7-12.702-12.7zm-51.006-53.25c.65.51 1.518.939 2.501 1.34v-9.11c-1.364.48-2.501 1.13-3.272 1.92-.838.879-1.267 1.88-1.2 2.82.101 1.319 1.118 2.379 1.971 3.031zm19.448 20.709c-.27-.489-1.339-1.939-4.949-3.42v8.871c2.901-.74 4.708-2.031 5.021-3.07.429-1.481.077-2.11-.072-2.381zm-22.33.021c-.761-3.23-3.98-5.24-7.209-4.479a5.99 5.99 0 0 0-4.481 7.199c1.72 7.38 8.182 12.739 17.072 14.59v3.04c0 3.311 2.689 6.001 5.999 6.001s5.999-2.69 5.999-6.001v-2.699c8.36-1.261 14.711-5.681 16.528-11.921 1.2-4.111.834-8.111-1.069-11.55-2.559-4.64-7.758-8.09-15.458-10.29v-12.459c1.759.568 4.741 1.86 5.281 4.249.737 3.23 3.947 5.261 7.175 4.521a5.991 5.991 0 0 0 4.525-7.181c-1.441-6.33-6.683-11.19-14.374-13.328a31.19 31.19 0 0 0-2.607-.591v-2.871c0-3.309-2.689-5.999-5.999-5.999s-5.999 2.69-5.999 5.999v2.88c-4.501.851-8.785 2.731-11.921 6.001-3.238 3.369-4.838 7.631-4.52 12 .328 4.47 2.66 8.6 6.578 11.64 2.852 2.221 6.361 3.51 9.864 4.491v11.608c-2.694-.979-4.852-2.579-5.382-4.849zM307.42 53.294a6 6 0 0 1 7.532-3.91l11.439 3.62a6.002 6.002 0 0 1 3.913 7.531 6.016 6.016 0 0 1-7.541 3.909l-11.444-3.62a6.006 6.006 0 0 1-3.898-7.531zm34.632 12.02a6.002 6.002 0 0 1 8.119-2.461l10.582 5.661a6 6 0 0 1-5.663 10.581l-10.582-5.66c-2.92-1.56-4.028-5.201-2.457-8.12zm116.819 139.969a6.17 6.17 0 0 1-1.788.271 6 6 0 0 1-5.72-4.22l-3.561-11.459c-.983-3.172.79-6.532 3.946-7.51a5.996 5.996 0 0 1 7.512 3.949l3.561 11.46c.978 3.16-.79 6.531-3.951 7.51zM50.59 318.435a6.012 6.012 0 0 1 3.84-7.571 5.994 5.994 0 0 1 7.561 3.842l2.53 7.71c1.022 3.158-.689 6.539-3.841 7.569a6.031 6.031 0 0 1-1.869.301 6.015 6.015 0 0 1-5.7-4.141l-2.52-7.71zm-8.076-39.4c-.419-3.279 1.899-6.29 5.18-6.71a5.996 5.996 0 0 1 6.717 5.18l1.532 11.911a6.003 6.003 0 0 1-5.96 6.759 6 6 0 0 1-5.941-5.229zm21.125-98.32a5.897 5.897 0 0 1-2.53-.57 5.996 5.996 0 0 1-2.901-7.97l3.903-8.359a5.999 5.999 0 0 1 7.97-2.901 6.005 6.005 0 0 1 2.901 7.97l-3.903 8.361a5.984 5.984 0 0 1-5.44 3.469zM48.32 233.086c3.301.199 5.821 3.049 5.623 6.349l-.723 11.981a5.99 5.99 0 0 1-5.98 5.639c-.12 0-.251 0-.371-.009a5.999 5.999 0 0 1-5.628-6.351l.718-11.979c.212-3.311 3.05-5.801 6.361-5.63zm-2.298-22.45 2.949-11.631c.819-3.209 4.082-5.159 7.291-4.341 3.209.812 5.161 4.081 4.341 7.29l-2.954 11.631a5.996 5.996 0 0 1-5.806 4.529c-.491 0-.983-.059-1.479-.189-3.209-.811-5.151-4.081-4.341-7.29zm239.397 252.42a6.005 6.005 0 0 1-5.527 6.439l-11.97.911c-.149.009-.308.009-.463.009a6 6 0 0 1-5.98-5.54 6.007 6.007 0 0 1 5.532-6.441l11.97-.909a6.012 6.012 0 0 1 6.438 5.53zm-115.287-16.361a5.986 5.986 0 0 1-5.3 3.181 5.94 5.94 0 0 1-2.809-.7l-10.601-5.63c-2.92-1.561-4.038-5.19-2.482-8.111a6.004 6.004 0 0 1 8.115-2.491l10.596 5.63a6 6 0 0 1 2.482 8.12zm189.287-8.92c1.455 2.982.202 6.571-2.776 8.021l-10.794 5.24c-.848.41-1.735.6-2.617.6a5.992 5.992 0 0 1-5.402-3.381 5.997 5.997 0 0 1 2.78-8.02l10.789-5.24a5.998 5.998 0 0 1 8.018 2.78zm-35.808 16.131a6.012 6.012 0 0 1-4.23 7.36l-11.579 3.13a5.989 5.989 0 0 1-7.358-4.231 6.005 6.005 0 0 1 4.226-7.36l11.579-3.131a6.013 6.013 0 0 1 7.362 4.232zm-116.308 5.479a6.016 6.016 0 0 1-5.729 4.23 6.19 6.19 0 0 1-1.783-.269l-11.459-3.55a6.004 6.004 0 1 1 3.551-11.471l11.459 3.55a6.003 6.003 0 0 1 3.961 7.51zm184.281-44.149a5.991 5.991 0 0 1-1.234 8.39l-9.618 7.17a6.01 6.01 0 0 1-3.58 1.189 6.006 6.006 0 0 1-4.819-2.419 5.99 5.99 0 0 1 1.229-8.391l9.618-7.17a6.006 6.006 0 0 1 8.404 1.231zm-145.403 49.67c-.337 3.059-2.939 5.329-5.946 5.329a7.84 7.84 0 0 1-.684-.039l-11.917-1.35c-3.301-.371-5.671-3.341-5.291-6.63.371-3.29 3.339-5.671 6.631-5.291l11.916 1.34c3.301.38 5.672 3.35 5.291 6.64zm211.872-192.25.728-11.97c.202-3.311 3.06-5.81 6.351-5.632a6.006 6.006 0 0 1 5.628 6.36l-.728 11.971a6.008 6.008 0 0 1-5.99 5.639c-.12 0-.241 0-.371-.01-3.301-.201-5.821-3.051-5.618-6.36zm-1.532-47.5c-.381-3.29 1.99-6.26 5.281-6.641a5.988 5.988 0 0 1 6.64 5.28l1.368 11.921c.371 3.29-1.99 6.27-5.276 6.639a5.996 5.996 0 0 1-6.65-5.28l-1.364-11.919zM195.343 80.864a6.004 6.004 0 0 1 5.999-5.999h31.731c3.305 0 5.999 2.69 5.999 5.999s-2.694 6.001-5.999 6.001h-31.731a5.998 5.998 0 0 1-5.999-6.001zm-130.76 0a5.997 5.997 0 0 1 5.999-5.999h31.717a6 6 0 1 1 0 12H70.582a5.992 5.992 0 0 1-5.999-6.001zm77.836-9.33c-.968-.749-2.159-1.99-2.279-3.569-.077-1.129.419-2.321 1.421-3.36.969-1.011 2.472-1.799 4.26-2.351v11.031c-1.349-.499-2.53-1.069-3.402-1.751zm21.544 21.671c.289.519.569 1.319.106 2.889-.429 1.481-2.809 2.961-6.25 3.731V89.096c4.351 1.659 5.729 3.37 6.144 4.109zm-24.792.329a5.997 5.997 0 0 0-7.199-4.48c-3.228.751-5.243 3.981-4.481 7.211 1.821 7.83 8.779 13.51 18.33 15.39v3.629c0 3.311 2.689 6.001 5.999 6.001s5.999-2.69 5.999-6.001v-3.3c8.004-1.139 15.603-5.099 17.771-12.519 1.253-4.301.872-8.47-1.123-12.071-2.689-4.86-8.187-8.51-16.35-10.829-.096-.03-.198-.051-.299-.081v-14.3c1.802.51 5.84 1.98 6.539 5.05.742 3.24 3.961 5.259 7.185 4.52a5.992 5.992 0 0 0 4.52-7.179c-1.513-6.641-7.021-11.731-15.121-13.98a28.353 28.353 0 0 0-3.122-.679v-3.462c0-3.309-2.679-5.999-5.999-5.999s-5.999 2.69-5.999 5.999v3.51c-4.949.881-9.628 2.901-12.919 6.33-3.383 3.52-5.06 7.979-4.722 12.549.342 4.67 2.79 8.99 6.891 12.171 3.089 2.4 6.929 3.789 10.75 4.83v13.409c-3.291-1.069-5.999-2.959-6.65-5.72zM36.379 53.074v55.59c8.134 2.152 14.543 8.57 16.692 16.691H250.57c2.154-8.12 8.573-14.539 16.692-16.691v-55.59c-8.119-2.159-14.538-8.57-16.692-16.7H53.071c-2.149 8.13-8.558 14.541-16.692 16.7zm-5.999 66.81c6.322 0 11.473 5.15 11.473 11.471a5.99 5.99 0 0 0 5.999 5.999h207.951a5.996 5.996 0 0 0 5.999-5.999c0-6.321 5.142-11.471 11.459-11.471a5.99 5.99 0 0 0 5.999-5.999v-66.04a5.998 5.998 0 0 0-5.999-6.001c-6.317 0-11.459-5.139-11.459-11.469 0-3.311-2.689-6-5.999-6H47.852a5.997 5.997 0 0 0-5.999 6c0 6.33-5.151 11.469-11.473 11.469a6.004 6.004 0 0 0-5.999 6.001v66.041a5.998 5.998 0 0 0 5.999 5.999zm256.262 24.85V16.993H17.003v127.741zm11.998 6.001V10.994a5.997 5.997 0 0 0-5.999-5.999H10.999A6.006 6.006 0 0 0 5 10.994v139.741a6 6 0 0 0 5.999 5.999h281.642a5.99 5.99 0 0 0 5.999-5.999zm38.621 22.439a6.518 6.518 0 0 1 3.942-3.02c3.445-.92 7.006 1.141 7.936 4.589a6.484 6.484 0 0 1-4.587 7.941 6.388 6.388 0 0 1-4.91-.651c-1.503-.87-2.583-2.259-3.021-3.94a6.433 6.433 0 0 1 .641-4.92zm-46.76 64.471a6.397 6.397 0 0 1-3.932 3.021 6.461 6.461 0 0 1-4.92-.642 6.485 6.485 0 0 1-3.021-3.939 6.417 6.417 0 0 1 .655-4.919 6.405 6.405 0 0 1 3.927-3.021 6.5 6.5 0 0 1 1.691-.22c1.118 0 2.231.289 3.228.87a6.443 6.443 0 0 1 3.021 3.941 6.387 6.387 0 0 1-.651 4.909zm-61.713-19.48a6.491 6.491 0 0 1-7.936-4.589 6.369 6.369 0 0 1 .651-4.911 6.419 6.419 0 0 1 3.927-3.019h.01a6.394 6.394 0 0 1 1.682-.232c1.128 0 2.231.301 3.228.872a6.452 6.452 0 0 1 3.021 3.939c.93 3.451-1.128 7.01-4.582 7.94zm-57.781 56.921a6.402 6.402 0 0 1-4.915-.651 6.405 6.405 0 0 1-3.021-3.93 6.475 6.475 0 0 1 .65-4.918 6.435 6.435 0 0 1 3.942-3.021c3.45-.93 7.006 1.131 7.927 4.58.93 3.45-1.132 7.011-4.582 7.941zm155.865-107.901a18.369 18.369 0 0 1 11.218-8.619c9.85-2.631 20.002 3.23 22.638 13.069 1.282 4.77.621 9.75-1.85 14.031a18.37 18.37 0 0 1-11.218 8.61c-1.59.42-3.209.63-4.809.63-2.79 0-5.551-.63-8.09-1.88l-33.268 33.261c.516 1.059.94 2.179 1.248 3.339 1.282 4.772.617 9.751-1.85 14.022a18.29 18.29 0 0 1-11.223 8.609c-1.585.429-3.209.64-4.809.64-3.2 0-6.356-.84-9.209-2.481-4.279-2.469-7.329-6.46-8.611-11.218a18.931 18.931 0 0 1-.621-5.542l-25.206-9.82a18.417 18.417 0 0 1-14.09 6.55c-2.901 0-5.71-.7-8.23-1.959l-32.902 32.409c.482 1.02.891 2.08 1.2 3.209 2.631 9.841-3.228 19.99-13.068 22.631a18.34 18.34 0 0 1-14.032-1.85 18.341 18.341 0 0 1-8.606-11.22c-1.272-4.77-.622-9.749 1.85-14.019 2.467-4.281 6.447-7.33 11.218-8.61 4.529-1.21 9.107-.61 13.001 1.329l32.897-32.41a19.765 19.765 0 0 1-1.19-3.209 18.359 18.359 0 0 1 1.85-14.021c2.472-4.278 6.452-7.339 11.223-8.609 4.77-1.28 9.748-.629 14.017 1.841 4.284 2.47 7.344 6.46 8.611 11.22a18.6 18.6 0 0 1 .622 5.54l25.211 9.82a18.314 18.314 0 0 1 9.319-5.92 18.378 18.378 0 0 1 12.88 1.259l33.278-33.279a18.41 18.41 0 0 1-1.238-3.332c-1.282-4.77-.631-9.749 1.841-14.019zm26.286 174.88v-119.07h-20.99v119.07zm6.004-131.07h-32.994a6.004 6.004 0 0 0-5.999 5.999v131.07a6.004 6.004 0 0 0 5.999 6.001h32.994c3.32 0 5.999-2.69 5.999-6.001v-131.07a5.997 5.997 0 0 0-5.999-5.999zm-63.78 131.07v-67.09h-20.99v67.09zm-26.994-79.09a6.007 6.007 0 0 0-5.999 6.001v79.089a6.007 6.007 0 0 0 5.999 6.001h32.993c3.32 0 5.999-2.69 5.999-6.001v-79.089a5.998 5.998 0 0 0-5.999-6.001zm-30.777 79.09v-83.971h-20.99v83.971zm5.999-95.971h-32.989a6.002 6.002 0 0 0-6.004 6.001v95.969a6.002 6.002 0 0 0 6.004 6.001h32.989a6.003 6.003 0 0 0 5.999-6.001v-95.969a6.004 6.004 0 0 0-5.999-6.001z"
        opacity="1"
        data-original="#021047"
        className=""
      />
    </svg>
  )
}

export default memo(SpinnerSVG)
